var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.open)?_c('div',{staticClass:"modals"},[_c('CardProject'),_c('CardCompany'),_c('CardRecord'),_c('CardUser')],1):_vm._e(),(_vm.document)?_c('div',[_c('CardDocument')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }